import { Link } from 'react-router-dom';
import { MenuProps } from 'antd';
import { TFunction } from 'react-i18next';

export const getProfileMenuItems = (
  allowedToViewCard: boolean,
  t: TFunction<'translation', undefined>,
): MenuProps['items'] => {
  const items = [
    {
      label: <Link to="/profile">{t('header.profileMenu.profile')}</Link>,
      key: 'profile',
    },
    {
      label: <Link to="/dependents">{t('header.profileMenu.dependents')}</Link>,
      key: 'dependents',
    },
    {
      label: <Link to="/medical-card">{t('header.profileMenu.medicalCard')}</Link>,
      key: 'medical-card',
    },
    {
      label: <Link to="/settings">{t('header.profileMenu.settings')}</Link>,
      key: 'settings',
    },
  ];

  return allowedToViewCard ? items : items.filter((item) => item?.key !== 'medical-card');
};
